import api from "./api";

export async function updateIndustry(token: string, industryKey: string) {
  const res = await api.patch(
    "/shops/industry",
    { industryKey },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data as { message: string; industryKey: string };
}

